import Box from "@mui/material/Box";

export type EmtMenuBackgroundProps = {
  /**
   * Opacity of the background
   * @default 47
   */
  opacity?: number;
  nonce?: string;
};

export function EmtMenuBackground(props: EmtMenuBackgroundProps) {
  const { opacity = 47 } = props;
  return (
    <Box
      sx={{
        position: "fixed",
        width: "100%",
        height: "100%",
        background: `#000000${opacity}`,
        zIndex: 11,
        top: 0,
      }}
    />
  );
}
